export type TaskContextSyncState = "synced" | "pending" | "failed";

export interface TaskContextModel {
  readonly taskId: string;
  readonly title: string;
  readonly status: string | null;
  readonly priority: string | null;
  readonly projectName: string | null;
  /**
   * The project's own identity, so this surface names a project the same way
   * every list does. Optional because a task can be read before its project
   * row has arrived.
   */
  readonly projectIcon: string | null;
  readonly projectIconUrl: string | null;
  readonly campaignName: string | null;
  readonly workspaceName: string | null;
  readonly sourceUrl: string | null;
  readonly syncState: TaskContextSyncState;
}

export interface BuildTaskContextModelInput {
  readonly taskId: string | null;
  readonly task:
    | {
        readonly id: string;
        readonly title: string;
        readonly status: string | null;
        readonly priority: string | null;
        readonly projectId: string | null;
        readonly campaignId: string | null;
        readonly workspaceName?: string | null;
      }
    | null
    | undefined;
  readonly projectName: string | null;
  readonly projectIcon?: string | null | undefined;
  readonly projectIconUrl?: string | null | undefined;
  readonly campaignName: string | null;
  readonly workspaceName: string | null;
  readonly sourceUrl: string | null;
  readonly syncState?: TaskContextSyncState | undefined;
}

export function buildTaskContextModel(input: BuildTaskContextModelInput): TaskContextModel | null {
  const taskId = input.task?.id ?? input.taskId;
  if (!taskId) return null;

  return {
    taskId,
    title: input.task?.title?.trim() || "CMMD task",
    status: input.task?.status ?? null,
    priority: input.task?.priority ?? null,
    projectName: input.projectName,
    projectIcon: input.projectIcon ?? null,
    projectIconUrl: input.projectIconUrl ?? null,
    campaignName: input.campaignName,
    workspaceName: input.task?.workspaceName ?? input.workspaceName,
    sourceUrl: input.sourceUrl,
    syncState: input.syncState ?? "synced",
  };
}
